import React, { useEffect } from 'react'

import { useActionRunner } from 'src/modules/notification'

import { usePurchasing } from '../hooks'
import SubmittedOrderList from './SubmittedOrderList'

const SubmittedOrderListView = () => {
  const { fetchOrderList, orderList, purchasingEnvironment } = usePurchasing()
  const [doFetchOrderList, isFetching] = useActionRunner(fetchOrderList, {
    initialFetchingState: true,
  })

  useEffect(() => {
    doFetchOrderList(purchasingEnvironment)
  }, [purchasingEnvironment])

  if (isFetching) {
    return null
  }

  return <SubmittedOrderList orders={orderList} />
}

export default SubmittedOrderListView
